import React from 'react';
import { motion } from 'framer-motion';
export function Leadership() {
  return <section className="py-24 bg-charcoal text-white relative overflow-hidden" data-id="element-94">
      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gold/5 blur-3xl rounded-full translate-x-1/2" data-id="element-95" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10" data-id="element-96">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-97">
          {/* Image Column */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="relative" data-id="element-98">
            <div className="absolute -inset-4 border border-gold/30 rounded-2xl translate-x-4 translate-y-4 -z-10" data-id="element-99" />
            <div className="relative rounded-2xl overflow-hidden aspect-[4/5] shadow-2xl" data-id="element-100">
              <img src="https://cdn.magicpatterns.com/uploads/nFyUPxQxFYi6Ao2fdJq2BA/grisel.png" alt="Grisel Jiménez - Fundadora y Directora" className="w-full h-full object-cover object-top" data-id="element-101" />
              <div className="absolute inset-0 bg-gradient-to-t from-charcoal/80 via-transparent to-transparent" data-id="element-102" />
              <div className="absolute bottom-0 left-0 p-8" data-id="element-103">
                <p className="font-playfair text-2xl font-semibold text-white" data-id="element-104">
                  Grisel Jiménez
                </p>
                <p className="text-gold text-sm tracking-widest uppercase mt-1" data-id="element-105">
                  Fundadora & Directora
                </p>
              </div>
            </div>
          </motion.div>

          {/* Text Column */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          ease: 'easeOut',
          delay: 0.2
        }} className="flex flex-col justify-center" data-id="element-106">
            <span className="text-gold font-semibold tracking-widest uppercase text-sm mb-6 block" data-id="element-107">
              Nuestra Dirección
            </span>

            <h2 className="text-4xl md:text-5xl lg:text-6xl font-playfair leading-tight mb-8" data-id="element-108">
              Liderazgo con{' '}
              <span className="italic text-gold" data-id="element-109">Ética y Pasión.</span>
            </h2>

            <div className="space-y-6 text-white/80 text-lg font-light leading-relaxed" data-id="element-110">
              <p data-id="element-111">
                Grisel Jiménez dirige Grand Town con un enfoque inquebrantable
                en la excelencia personalizada. Entendemos que su propiedad no
                es solo un activo, es el resultado de su esfuerzo y visión.
              </p>
              <p data-id="element-112">
                Su camino a la certificación AMPI reafirma nuestro compromiso
                con los estándares más altos de la industria inmobiliaria en
                México, garantizando prácticas legales, transparentes y
                altamente rentables para cada uno de nuestros clientes.
              </p>
            </div>

            <div className="mt-12 flex items-center gap-6" data-id="element-113">
              <div className="w-16 h-px bg-gold" data-id="element-114" />
              <p className="font-playfair italic text-xl text-white/90" data-id="element-115">
                "Su tranquilidad es nuestra mayor inversión."
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}